import { Fragment } from "react";

import { api } from "../client";
import {
  ApiPaths,
  Connection,
} from "@/providers/smarta-documents/documents-api-client";
import { ConnectionTable } from "./ConnectionTable";
import { Spacer } from "../../components/styles";

type Props = {
  customerId: string;
};

export const ConnectionsOverview = ({ customerId }: Props) => {
  const { data: connections } = api.useQuery(
    "get",
    ApiPaths.getApiConnectionsByCustomerId,
    {
      params: { path: { customerId } },
    }
  );

  if (!connections?.data?.length) {
    return null;
  }

  return (
    <>
      {connections.data.map((connection: Connection, i: number) => {
        return (
          <Fragment key={connection.targetSystem + i}>
            <ConnectionTable customerId={customerId} data={connection} />
            <Spacer>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </Spacer>
          </Fragment>
        );
      })}
    </>
  );
};
